import { useAppDispatch, useAppSelector } from '~system/store/configure-store';
import { selectSpecificModal } from '~system/store/modal/modal-selectors';
import {
  openSpecificModal as openSpecificModalAction,
  closeSpecificModal as closeSpecificModalAction,
  SpecificModalType,
} from '~system/store/modal/modal-slice';

export const useSpecificModal = () => {
  const dispatch = useAppDispatch();
  const activeSpecificModal = useAppSelector(selectSpecificModal);

  const openSpecificModal = ({ ...props }: SpecificModalType) => {
    dispatch(openSpecificModalAction(props));
  };

  const closeSpecificModal = () => {
    dispatch(closeSpecificModalAction());
  };

  return {
    activeSpecificModal,
    openSpecificModal,
    closeSpecificModal,
  };
};
